var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    height: 64,
    id: "Layer_1",
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Question"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.358,53.044l2.076,7.038a1,1,0,0,1-1.308,1.22l-6.15-2.29a2.936,2.936,0,0,0-2.5.191A20.739,20.739,0,0,1,41,62.07,27.623,27.623,0,0,1,31.76,60h-.01c-6.731-3.868-11.432-10.215-11.735-18.118A21.154,21.154,0,0,1,39.933,20.061a20.985,20.985,0,0,1,19.618,30.8A2.91,2.91,0,0,0,59.358,53.044Z",
    fill: "#cacbcc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.459,52.034a2.942,2.942,0,0,1,2.568.213A25.839,25.839,0,0,0,28.5,56,26.752,26.752,0,0,0,55,29,26.752,26.752,0,0,0,28.5,2,26.752,26.752,0,0,0,2,29,27.285,27.285,0,0,0,5.206,41.9a3.068,3.068,0,0,1,.214,2.293L2.557,54.077A1,1,0,0,0,3.872,55.29Z",
    fill: "#30b2e5"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c95757",
    points: "31.97 60 31.99 59.98 32.01 60 31.97 60"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#c95757",
    points: "32.01 56 31.97 56 31.99 55.98 32.01 56"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ea5c6d",
    points: "31.01 60 30.97 60 30.99 59.98 31.01 60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75,56.82c-.55-.22-1.08-.46-1.61-.71l.3-.11C14.87,56.29,15.31,56.56,15.75,56.82Z",
    fill: "#e3e6e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,35H26V31.276a3.815,3.815,0,0,1,3.343-3.741,3.984,3.984,0,0,0,3.632-4.669,4.43,4.43,0,0,0-3.837-3.824,4.6,4.6,0,0,0-3.685,1.092A4.2,4.2,0,0,0,24,23H19a8.42,8.42,0,0,1,3.151-6.695,9.663,9.663,0,0,1,7.626-2.259,9.432,9.432,0,0,1,8.176,8.328C38.413,27.21,36,31.249,31,32.31Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 5,
    width: 5,
    x: 26,
    y: 38
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddQuestion);
export default __webpack_public_path__ + "static/media/AddQuestion.d994f866537e97fbe3e5779791543730.svg";
export { ForwardRef as ReactComponent };